import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { FaDownload } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./MyTrainingDetails.css";

function MyTrainingDetails() {
  const [isLoading, setIsLoading] = useState(true);
  const [training, setTraining] = useState({});
  const [user, setUser] = useState({});

  const { state } = useContext(AuthContext);

  let { tid, uid } = useParams();

  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const result = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainings/user/detail`,
        data: {
          userId: uid,
          trainingId: tid,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      setTraining(result.data.training);
      setUser(result.data.user);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, tid, uid]);

  const formatDate = (date) => {
    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth() + 1;
    const day = new Date(date).getDate();

    return day + "/" + month + "/" + year;
  };

  const handleDownloadEvidence = async () => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/trainings/download/file`,
      data: {
        key: training._id + "-" + user._id + "-" + training.fileName,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });

    const link = document.createElement("a");
    link.download = training.fileName;

    link.target = "_blank";

    link.href = response.data.url;

    link.click();
  };

  const validateTraining = async () => {
    await axios({
      method: "put",
      url: `${process.env.REACT_APP_BACKEND_URL}/trainings/validate/training`,
      data: {
        trainingId: training._id,
        userId: user._id,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    navigate(`/mytrainings/${user._id}`);
  };

  if (isLoading === true) {
    return <Spinner animation="border" role="status" />;
  } else {
    return (
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={10} className="mytraining-details">
            <Form>
              <Row className="justify-content-center">
                <Col className="mytraining-details-alert mb-3">
                  <Alert variant="info">
                    <Row>
                      <Col>
                        {t("Capacitaciones.MisCapacitaciones.Detalles.Alert")}
                      </Col>
                    </Row>
                  </Alert>
                </Col>
              </Row>

              <Row className="justify-content-center align-items-center">
                <Col className="mytraining-details-title">
                  <Row>
                    <Col>
                      <h5>
                        {training.name} - {training.trainingGroupName}
                      </h5>
                      <p>
                        Completada el:
                        {training.completed_at
                          ? " " + formatDate(training.completed_at)
                          : ""}
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className="align-items-center justify-content-center">
                {training.fileName === "" ? (
                  <Col className="mytraining-details-noFiles">
                    <p>
                      {t(
                        "Capacitaciones.MisCapacitaciones.Detalles.NoReferenceFile"
                      )}
                    </p>
                  </Col>
                ) : (
                  <Col className="mytraining-details-files mb-3 mt-3">
                    <span className="download-container">
                      <FaDownload />
                      <span onClick={() => handleDownloadEvidence()}>
                        {training.fileName}
                      </span>
                    </span>
                  </Col>
                )}
              </Row>

              <Row className="justify-content-center">
                <Col className="mytraining-details-buttons">
                  <Button variant="primary" onClick={() => validateTraining()}>
                    {t(
                      "Capacitaciones.MisCapacitaciones.Detalles.ValidarCumplimiento"
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default MyTrainingDetails;
